import { BaseService } from "@flint/framework";

export default class AddGenusSpeciality extends BaseService {
  constructor() {
    super("Add_GenusSpeciality", "AddGenusSpecialityStore", true);
  }

  handleEvent(eventName, event) {
     return this.getClient("vetService").post(`/admin-api/master/genus-specialty`, null, {
       params: {
         "key": event.event.key,
         "value": event.event.value
       }
     });
  }
}